import { render, staticRenderFns } from "./ClosedDates.vue?vue&type=template&id=62b99554"
import script from "./ClosedDates.vue?vue&type=script&lang=ts"
export * from "./ClosedDates.vue?vue&type=script&lang=ts"
import style0 from "./ClosedDates.vue?vue&type=style&index=0&id=62b99554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports